import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import lodash from 'lodash';

import { isPropSet } from 'utils/props';

import TextInput from 'components/forms/TextInput';
import SelectInput from 'components/forms/SelectInput';
import { ActionButton, SaveButton, DeleteIconButton } from 'components/Button';
import { SettingsIcon } from 'components/Svg';


// ======================
// HELPERS
// ====================== 

const BACKGROUND_COLORS = (
  <>
    <option value="">None</option>
    <option value="black">Black</option>
    <option value="white">White</option>
  </>
)

const REQUIRES_OPACITY = ['black', 'white'];


// ======================
// PARTIALS
// ====================== 


const SectionHead = p => (
  <div className="settings-head">
    <h3 className="title">{ p.title }</h3>
  </div>
)


// ======================
// COMPONENT
// ====================== 


class OverlaySettings extends React.Component {
  state = {
    
  }
  static defaultProps = {
    settings: { 
      length: 5000,
      pause: 0,
      slideBreak: 0,
      background: '',
      backgroundOpacity: 100 },
  }


  componenDidUpdate(prev) {
    if(isPropSet(prev, this.props, 'selectedScene._id')) {
      
    }
  }

  format = (name, val) => {
    switch(name) {
      case 'length':
      case 'pause':
        val = (val || 0) / 1000;
        break;
      case 'slideBreak':
        val = (val || 0) / 1000;
        break;
      case 'backgroundOpacity':
        val = _.toString(val);
    }
    return val ?? '';
  }

  transform = (name, val) => {
    switch(name) {
      case 'length':
      case 'pause':
        return val * 1000;
      case 'slideBreak':
        return val * 1000;
      case 'background':
        return _.isEmpty(val) 
          ? null
          : val;
      case 'backgroundOpacity':
        return _.chain(val)
          .toNumber()
          .thru(v => Math.min(Math.max(v, 0), 100))
          .value();
      default:
        return val;
    }
  }

  getSceneInputProps = (name, label, scene, sceneSettings, overlaySettings) => {
    let val = sceneSettings?.[name] !== undefined 
      ? sceneSettings?.[name]
      : overlaySettings?.[name];
    let isCustom = !_.isUndefined(sceneSettings?.[name]) && !_.isEqual(sceneSettings?.[name], overlaySettings?.[name]);
    return {
      name,
      label: isCustom ? <><span>{label}<span className="custom">*</span></span></> : label,
      className: cx({ custom: isCustom }),
      labelExtra: isCustom && <span className="reset" onClick={() => this.onRemoveSetting(name)}>reset</span>,
      value: this.format(name, val),
      onChange: (value, name, e) => this.onChange(value, name, e, scene._id),
    }
  }

  onChange = (value, name, e, sceneId) => {
    let { onOverlaySettingsChange, onSceneSettingsChange, overlaySettings, sceneSettings } = this.props;
    value = this.transform(name, value);

    if(sceneId) {
      let settings = sceneSettings[sceneId]?.settings ?? {};
      if(overlaySettings?.[name] === value) {
        settings[name] = undefined;
      } else {
        _.set(settings, name, value);
      }
      onSceneSettingsChange?.(sceneSettings, sceneId);
    } else {
      onOverlaySettingsChange?.({
        ...overlaySettings, 
        [name]: value 
      });
    }
  }

  onRemoveSetting = name => {
    let { selectedScene, sceneSettings, overlaySettings, onSceneSettingsChange } = this.props;
    let settings = sceneSettings?.[selectedScene._id]?.settings;
    settings[name] = overlaySettings[name]; //reset to base settings
    onSceneSettingsChange?.(sceneSettings, selectedScene._id);
  }

  onSceneSaveClick = e => this.props.onSlideSave?.()
  onSceneDeleteClick = e => this.props.onSlideDelete?.(this.props.selectedScene?._id)

  
  render() {
    let { showGeneral = true, overlaySettings, selectedScene, sceneSettings, errors } = this.props;
    let selectedSettings = _.find(sceneSettings, { sceneId: selectedScene?._id })?.settings ?? {};
    let background = selectedSettings?.background ?? overlaySettings?.background;
    
    return (
      <div className="g-overlay-settings">
        <div className="settings-section">
          <TextInput
            name="length"
            label="Slide Length (sec)"
            value={this.format('length', overlaySettings?.length)}
            errors={errors.length}
            onChange={this.onChange} />
          <TextInput
            name="slideBreak"
            label="Pause Between Slides (sec)"
            value={this.format('slideBreak', overlaySettings?.slideBreak ?? 0)}
            errors={errors.length}
            onChange={this.onChange} />
          <TextInput
            name="pause"
            label="Pause Between Loops (sec)"
            value={this.format('pause', overlaySettings?.pause)}
            errors={errors.length}
            onChange={this.onChange} />
        </div>
        <div className="settings-section">
          <SelectInput
            name="background"
            label="Background"
            value={this.format('background', overlaySettings?.background || '')}
            errors={errors.background}
            onChange={this.onChange}>
            {BACKGROUND_COLORS}
          </SelectInput>
          {REQUIRES_OPACITY.includes(overlaySettings?.background) &&
            <TextInput
              name="backgroundOpacity"
              label="Opacity"
              type="number"
              max={100}
              min={0}
            value={_.toString(overlaySettings.backgroundOpacity)}
              errors={errors.backgroundOpacity}
              onChange={this.onChange} />}
        </div>

        { selectedScene && false &&
        <div className="scene-settings">
          <SectionHead image={selectedScene.url} title={<><SettingsIcon /> Custom Settings</>} />
          <div className="slide-logo"><img src={selectedScene.url} /></div>
          <div className="settings-content">
            <div className="settings-section">
              <TextInput
                {...this.getSceneInputProps('length', 'Slide Length (sec)', selectedScene, selectedSettings, overlaySettings) }/>
              <SelectInput
                {...this.getSceneInputProps('background', 'Background', selectedScene, selectedSettings, overlaySettings)}>
                {BACKGROUND_COLORS }
              </SelectInput>
              {REQUIRES_OPACITY.includes(background) &&
              <TextInput
                type="number"
                max={100}
                min={0}
                {...this.getSceneInputProps('backgroundOpacity', 'Opacity', selectedScene, selectedSettings, overlaySettings)} />}
            </div>
            <div className="settings-section actions">
              <SaveButton onClick={this.onSceneSaveClick} />
              <DeleteIconButton color="light" onClick={this.onSceneDeleteClick} />
            </div>
          </div>
        </div> }

        {!showGeneral && !selectedScene && 
        <div className="info">Click on a slide to customize settings</div>}
      </div>)
  }
}

export default OverlaySettings;